import classNames from '@/common/utils/classNames';
import { useUserInfoStore } from '@/modules/login/store/userInfo';
import { useActingDoctor } from '@/modules/doctorPanel/secretary/gateway';
import { DoctorHomeFeed } from './components/doctorHomeFeed';
import { SecretaryHomeFeed } from './components/secretaryHomeFeed';
import { ds } from './designSystem';
import { useDoctorHomeStats } from './hooks/useDoctorHomeStats';

export interface DoctorHomeOverviewProps {
  className?: string;
}

export const DoctorHomeOverview = ({ className }: DoctorHomeOverviewProps) => {
  const user = useUserInfoStore(state => state.info);
  const acting = useActingDoctor();
  // a secretary's home has no statistics (wallet, reviews…): do not fetch them
  useDoctorHomeStats(acting ? undefined : user);

  return (
    <div className={classNames(ds.layout.pagePadding, className)}>
      <div className={ds.layout.pageShell}>
        {acting ? <SecretaryHomeFeed /> : <DoctorHomeFeed />}
      </div>
    </div>
  );
};
